import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Calculator, Shield, ListChecks } from "lucide-react";

const ITEMS = [
  {
    icon: Calculator,
    title: "Calculadora de retiro",
    text: "Proyecta tu capital al cumplir 65 años con base en tu ahorro actual y aportaciones periódicas.",
    cta: "Calcular mi retiro",
  },
  {
    icon: Shield,
    title: "Estimación de protección",
    text: "Conoce cuánto debería cubrir tu seguro de vida para sostener a los tuyos sin alteraciones.",
    cta: "Estimar mi cobertura",
  },
  {
    icon: ListChecks,
    title: "Simulador de coberturas",
    text: "Responde 4 preguntas y recibe una recomendación priorizada de pólizas según tu perfil.",
    cta: "Iniciar simulador",
  },
];

const ToolsPreview = () => {
  return (
    <section className="py-24 lg:py-32 bg-razmek-alt">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-6">
            <div className="eyebrow">Herramientas</div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl mt-4 leading-[1.05] text-razmek-dark">
              Visualiza tu
              <br />
              <span className="italic text-razmek-blue">futuro financiero</span>.
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="font-sans text-base lg:text-lg leading-relaxed text-razmek-dark/70">
              Calculadoras simples y rigurosas para que entiendas, en minutos,
              el orden de magnitud de tu estrategia patrimonial.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <Link
                key={it.title}
                to="/herramientas"
                className="card-lift group bg-white p-8 lg:p-10 border border-razmek block"
              >
                <div className="flex items-start justify-between mb-12">
                  <Icon size={28} strokeWidth={1.3} className="text-razmek-blue" />
                  <span className="font-serif text-razmek-gray text-sm">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-serif text-2xl text-razmek-dark">
                  {it.title}
                </h3>
                <p className="font-sans text-sm leading-relaxed text-razmek-dark/70 mt-3">
                  {it.text}
                </p>
                <div className="mt-8 flex items-center gap-2 font-sans text-[11px] tracking-[0.18em] uppercase text-razmek-blue group-hover:text-razmek-gold transition-colors">
                  {it.cta}
                  <ArrowUpRight
                    size={14}
                    className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                  />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ToolsPreview;
